import { render, staticRenderFns } from "./GroupAddTabAccount.vue?vue&type=template&id=44a5ea88"
import script from "./GroupAddTabAccount.vue?vue&type=script&lang=js"
export * from "./GroupAddTabAccount.vue?vue&type=script&lang=js"
import style0 from "./GroupAddTabAccount.vue?vue&type=style&index=0&id=44a5ea88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports